import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useSession } from "./features/auth/useSession.js";
import { Landing } from "./routes/Landing.js";
import { Login } from "./routes/Login.js";
import { SignUp } from "./routes/SignUp.js";
import { Dashboard } from "./routes/Dashboard.js";
import { ClubView } from "./routes/ClubView.js";
import { ClubBookView } from "./routes/ClubBookView.js";
import { ClubSearch } from "./routes/ClubSearch.js";
import { AcceptInvite } from "./routes/AcceptInvite.js";
import { PollView } from "./routes/PollView.js";
import { ReadingList } from "./routes/ReadingList.js";
import { AccountSettings } from "./routes/AccountSettings.js";

function RequireAuth({ children }: { children: React.ReactNode }) {
  const location = useLocation();
  const { data: me, isLoading } = useSession();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <span className="text-sm" style={{ color: "var(--color-muted-foreground)" }}>Loading…</span>
      </div>
    );
  }

  if (!me) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}

function RedirectIfAuthed({ children }: { children: React.ReactNode }) {
  const { data: me, isLoading } = useSession();
  if (isLoading) return null;
  if (me) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
}

export function App() {
  return (
    <>
    <Routes>
      <Route
        path="/"
        element={
          <RedirectIfAuthed>
            <Landing />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/login"
        element={
          <RedirectIfAuthed>
            <Login />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/signup"
        element={
          <RedirectIfAuthed>
            <SignUp />
          </RedirectIfAuthed>
        }
      />
      <Route
        path="/dashboard"
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      />
      <Route
        path="/clubs/:clubId"
        element={
          <RequireAuth>
            <ClubView />
          </RequireAuth>
        }
      />
      <Route
        path="/clubs/:clubId/books/:clubBookId"
        element={
          <RequireAuth>
            <ClubBookView />
          </RequireAuth>
        }
      />
      <Route
        path="/account"
        element={
          <RequireAuth>
            <AccountSettings />
          </RequireAuth>
        }
      />
      <Route
        path="/reading-list"
        element={
          <RequireAuth>
            <ReadingList />
          </RequireAuth>
        }
      />
      <Route
        path="/clubs/:clubId/polls/:pollId"
        element={
          <RequireAuth>
            <PollView />
          </RequireAuth>
        }
      />
      <Route
        path="/search"
        element={
          <RequireAuth>
            <ClubSearch />
          </RequireAuth>
        }
      />
      <Route path="/invite/:token" element={<AcceptInvite />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}
